import type { InputHTMLAttributes, ReactNode, Ref } from 'react';

import { cn } from '@/lib/cn';

/**
 * The control inside a `Field`'s notched outline.
 *
 * It draws NOTHING of its own — no border, no fill. The outline `Field` paints around it is the
 * whole field, which is DESIGN.md §5's "én skillelinje, ikke to" and also the only way the
 * label can straddle the top border without a seam running through the word. `.field-control`
 * in `globals.css` carries the geometry; the focus ring is the one in `--focus-ring`, never
 * removed (§9).
 *
 * Every text-entry control in Tvitvi is rendered inside a `Field`. Used bare it would have no
 * visible boundary, which is the correct failure: a field without a name is not a field.
 */
export const INPUT_CLASS = cn('field-control');

export interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  ref?: Ref<HTMLInputElement>;
}

export function TextField({ className, type = 'text', ...rest }: TextFieldProps): ReactNode {
  return <input type={type} className={cn(INPUT_CLASS, className)} {...rest} />;
}
